<template>
    <div :class ="[vehicleSelected ? 'scheduleAppointmentButton' : 'openVehicleDisplayButton', 'ctaButton']" @click="buttonAction">
        {{ buttonText }}
    </div>
    
</template>

<script>
    export default {
        props: [
            'car'
        ],
        data() {
            return {

            }
        },
        computed: {
            vehicleSelected() {
                return this.$store.getters.vehicleGallerySelected != null;
            },
            buttonText() {
                return this.vehicleSelected ? "Hold This Vehicle" : 'VIEW HISTORY';
            }
        },
        methods: {
            buttonAction() {
                if(this.vehicleSelected) {
                    let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                    this.$gtag.event('open', {'event_category': 'schedule_appointment','event_label': eventLabel});
                    this.$store.dispatch('openAppInSeperateWindow', 'https://www.online.cars/schedule/');
                }
                else {
                    let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                    this.$gtag.event('open', {'event_category': 'vehicle_vdp','event_label': eventLabel});
                    this.$store.commit('setVehicleGallerySelected', this.car);
                }
            }
        }
    }
</script>

<style>
    .ctaButton {
        background-color: var(--mccluskeyGold);/*#0077C0;*//*#0079B6;*//*#AF873F;*/
        border-radius: calc(.5 * var(--vratio) * var(--vw)); /*calc(var(--vratio) * var(--vh));*//*5px;*/
        width: calc((19.2 * var(--vw)) - ((((16 * .9)/3) * 4.25) * var(--vh)));
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: bolder;
        color: white; /*#3378B1;*/
        font-size: calc(.9 * var(--vw));
        margin-top: calc(.75 * var(--vh));
        border: solid white 1.75px;
        padding: .1vh 0px;
    }

    .ctaButton.openVehicleDisplayButton {
        width: calc((19.2 * var(--vw)) - ((((16 * (1.4 - var(--vratio))) / 3) * 4) * var(--vh)));
    }

    .inmobile .ctaButton{
        width: calc(32 * var(--vw));
        height: calc(6 * var(--vh));/*calc(3 * var(--vh));*/
        font-size: inherit;/*calc(4 * var(--vh));*//*calc(1.8 * var(--vh));*/
        border-radius: calc(.5 * var(--vratio) * var(--vh))
    }

    .inmobile .ctaButton.scheduleAppointmentButton {
        width: calc(80 * var(--vw));
    }
    
    .ctaButton:hover {
        color: black;/*#2c3e50;*/
        border-color: var(--mccluskeyBlue); /*#AF873F;*/
    }
</style>